import Plausible from "plausible-tracker";
import {useEffect} from "react";
import {MotionConfig} from "framer-motion";
import "./App.scss";
import "./coder-theme.scss";
import {ContactSection} from "./components/ContactSection";
import {ExperienceSection} from "./components/ExperienceSection";
import {Footer} from "./components/Footer";
import {HeroSection} from "./components/HeroSection";
import {MetricsBand} from "./components/MetricsBand";
import {Navbar} from "./components/Navbar";
import {ProjectsSection} from "./components/ProjectsSection";
import {ResumeSection} from "./components/ResumeSection";
import {SkillsSection} from "./components/SkillsSection";
import {TestimonialsSection} from "./components/TestimonialsSection";

function App() {
    useEffect(() => {
        if (process.env.NODE_ENV !== "production") return;
        const plausible = Plausible({
            domain: "jarrodsavard.com",
            trackLocalhost: false,
        });
        return plausible.enableAutoPageviews();
    }, []);

    return (
        <MotionConfig reducedMotion="user"><div
            id="top"
            className="App">
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[60] focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded">
                Skip to content
            </a>
            <Navbar />
            <main id="main-content">
                <HeroSection />
                <ProjectsSection />
                <MetricsBand />
                <ExperienceSection />
                <SkillsSection />
                <TestimonialsSection />
                <ResumeSection />
                <ContactSection />
            </main>
            <Footer />
        </div></MotionConfig>
    );
}

export default App;
